/**
 * @ngdoc directive
 * @name footerpanelcontacts
 *
 * @description
 * Extended footer version : contact panel
 */
module.directive('footerpanelcontacts', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            contacts: '=content',
            isHomepage: '=',
            faq: '='
        },
        controller: ['$scope', function ($scope) {
            // show/hide emails
            $scope.open = false;
            
            // retrieve emails
            $scope.emails = [];
            $scope.$watch('contacts', function (value) {
                if (value) {
                    $scope.emails = [
                        $scope.contacts.email_stagiaires,
                        $scope.contacts.email_moniteurs,
                        $scope.contacts.email_entreprises_collectivites
                    ];
                }
            });
        }],
        templateUrl: 'src/components/footerpanel/footer_contact.html'
    };
});